module.exports = __webpack_public_path__ + "static/media/codePeaches.23e9ecb6.jpg";